import { fromJS } from 'immutable';
import { DRAW_PRIZE, END_DRAW_PRIZE } from './constants';
import { APP_RESET } from '../App/constants';

const initialState = fromJS({
  drawing: false,
});

function reducer(state = initialState, action) {
  switch (action.type) {
    case DRAW_PRIZE:
      return state.set('drawing', true);

    case END_DRAW_PRIZE:
      return state.set('drawing', false);


    case APP_RESET:
      return initialState;

    default:
      return state;
  }
}

export default reducer;
